import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

/**
 * Footer Component
 */
export class FooterComponent implements OnInit {

  currentYear: number;

  constructor(private router: Router) {
    this.currentYear = new Date().getFullYear();

   }
 
  ngOnInit(): void {
    setInterval(() => {
      this.currentYear = new Date().getFullYear();
    }, 1000);
  }

  scrollTOView6(){

    window.scrollTo(0, 2);
    
  }
  scrollTOView1(){

    window.scrollTo(0, 2);
    
  }
  scrollTOView2(){

    window.scrollTo(0, 2);
    
  }
  scrollTOView3(){

    window.scrollTo(0, 2);
    
  }
  scrollTOView4(){

    window.scrollTo(0, 2);
    
  }
  scrollTOView5(){

    window.scrollTo(0, 2);
    
  }
  onClick6(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/service']);
    

    setTimeout(()=>{
    
    this.scrollTOView6();
    
    },800)
    
    } 
  }

  onClick1(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/track-order']);
    

    setTimeout(()=>{
    
    this.scrollTOView1();
    
    },800)
    
    } 
  }

  
  onClick2(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/services']);
    

    setTimeout(()=>{
    
    this.scrollTOView2();
    
    },800)
    
    } 
  }

  onClick3(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/about']);
    

    setTimeout(()=>{
    
    this.scrollTOView3();
    
    },800)
    
    } 
  }
  onClick4(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/contacts']);
    

    setTimeout(()=>{
    
    this.scrollTOView4();
    
    },800)
    
    } 
  }

  onClick5(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/']);
    

    setTimeout(()=>{
    
    this.scrollTOView5();
    
    },800)
    
    } 
  }


  scrollTOView9(){

    window.scrollTo(0, 2);
    
  }
  onClick9(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/terms']);
    

    setTimeout(()=>{
    
    this.scrollTOView9();
    
    },800)
    
    } 
  }

  scrollTOView11(){

    window.scrollTo(0, 2);
    
  }
  onClick11(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/privacy']);
    

    setTimeout(()=>{
    
    this.scrollTOView9();
    
    },800)
    
    } 
  }


}
